module.exports = __webpack_public_path__ + "img/1.ae47e3bf.jpg";